"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchStatus = void 0;
var FetchStatus;
(function (FetchStatus) {
    FetchStatus["PENDING"] = "pending";
    FetchStatus["RESOLVED"] = "resolved";
    FetchStatus["REJECTED"] = "rejected";
})(FetchStatus || (exports.FetchStatus = FetchStatus = {}));
//# sourceMappingURL=RequestEnums.js.map